import { useState } from "react";
import { toast } from "sonner";
import api from "@/api";
import { useAuth } from "@/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function ForcePasswordGate() {
  const { user, setUser } = useAuth();
  const [pwForm, setPwForm] = useState({ old_password: "", new_password: "" });
  if (!user?.force_password_change) return null;
  const changePw = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/change-password", pwForm);
      toast.success("Password updated");
      setUser({ ...user, force_password_change: false });
    } catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
  };
  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent data-testid="force-password-dialog" onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader><DialogTitle className="font-heading">Set your new password</DialogTitle></DialogHeader>
        <form onSubmit={changePw} className="space-y-3">
          <p className="text-sm text-muted-foreground">For security, you must set a new password before continuing.</p>
          <Input data-testid="force-old-password" type="password" placeholder="Current password" value={pwForm.old_password} onChange={(e) => setPwForm({ ...pwForm, old_password: e.target.value })} required />
          <Input data-testid="force-new-password" type="password" placeholder="New password (6+ chars)" value={pwForm.new_password} onChange={(e) => setPwForm({ ...pwForm, new_password: e.target.value })} required minLength={6} />
          <Button data-testid="force-password-submit" type="submit" className="w-full bg-primary hover:bg-primary-hover">Update Password</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
